// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7a3fb80146--wrapper--hG1x2"};